import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {StackParamList} from '../../../../navigators';
import {SuccessTemplate} from '../../../../components/templates/success';
import {PrimaryButton} from '../../../../components/buttons';
import {message} from '../../../../utils/messages';
import {useSalesmanContext} from '../../../../context/salesman';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'WithoutConnectionSaveSucess'
>;

const WithoutConnectionSaveSucess = ({navigation, route}: ScreenProps) => {
  const {} = useSalesmanContext();
  const {workflow} = route.params;
  const clearWorkflow = () => {};

  const handlePrimaryPress = () => {
    clearWorkflow();
    if (
      workflow === 'customer-registration' ||
      workflow === 'payment-proof' ||
      workflow === 'salesman-order'
    ) {
      navigation.navigate('SalesmanDashboard');
    }
  };

  const getTitle = () => {
    switch (workflow) {
      case 'customer-registration':
      case 'payment-proof':
      case 'salesman-order':
        return message('salesman-save-to-storage-sucess-title');
    }
    return '';
  };

  const getSummary = () => {
    switch (workflow) {
      case 'customer-registration':
        return message(
          'salesman-customer-registration-save-to-storage-sucess-button',
        );
      case 'payment-proof':
        return message('salesman-payment-proof-save-to-storage-sucess-button');
      case 'salesman-order':
        return message('salesman-salesman-order-save-to-storage-sucess-button');
    }
    return '';
  };

  return (
    <SuccessTemplate title={getTitle()} summary={getSummary()}>
      <PrimaryButton
        label={message('salesman-save-to-storage-sucess-button')}
        onPress={() => handlePrimaryPress()}
      />
    </SuccessTemplate>
  );
};
export default WithoutConnectionSaveSucess;
